import React from 'react';

/**
 * Live status indicator shown during Adult Mode real-time practice.
 * Displays mic state, current word index, error count, and progress bar.
 */
export const RealtimeStatusBar = ({
  isKidsMode,
  isMobile,
  isActive,         // mic actually active
  chunkMs = 5000,   // for label display
  currentWordIndex, // realtimeTracking.currentWordIndex
  errorsCount,      // realtimeTracking.errors.length
  lastResult,       // realtimeTracking.lastResult
}) => (
  <div
    className={`p-4 ${
      isKidsMode
        ? 'bg-green-100 rounded-3xl'
        : 'bg-green-50 rounded-xl border border-green-300'
    }`}
    data-testid="realtime-status-bar"
  >
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        <div className="relative">
          <div
            className={`w-3 h-3 rounded-full ${
              isActive ? 'bg-green-500 animate-pulse' : 'bg-gray-400'
            }`}
          ></div>
        </div>
        <span className="font-bold">
          {isActive
            ? '🎤 Canlı Dinleme Aktif' + (isMobile ? ` (${Math.round(chunkMs / 1000)} sn)` : '')
            : '⏸️ Duraklatıldı'}
        </span>
      </div>
      <div className="flex items-center gap-4 text-sm">
        <div>
          <span className="text-gray-600">Kelime:</span>{' '}
          <span className="font-bold">{currentWordIndex}</span>
        </div>
        <div>
          <span className="text-gray-600">Hata:</span>{' '}
          <span className="font-bold text-red-600">{errorsCount}</span>
        </div>
        {lastResult && (
          <div
            className={`px-3 py-1 rounded-full text-xs font-bold ${
              lastResult.is_correct ? 'bg-green-500 text-white' : 'bg-red-500 text-white'
            }`}
          >
            {lastResult.is_correct ? '✓ Doğru' : '✗ Hata'}
          </div>
        )}
      </div>
    </div>

    {lastResult?.progress_percentage !== undefined && (
      <div className="mt-3">
        <div className="w-full bg-gray-200 rounded-full h-2">
          <div
            className="bg-green-500 h-2 rounded-full transition-all duration-300"
            style={{ width: `${lastResult.progress_percentage}%` }}
          ></div>
        </div>
        <div className="text-xs text-gray-600 mt-1 text-right">
          {lastResult.progress_percentage.toFixed(0)}% tamamlandı
        </div>
      </div>
    )}
  </div>
);

export default RealtimeStatusBar;
